module.exports = __webpack_public_path__ + "img/knusprigeenteohnehintergrund.9b55b3f9.png";